const comments = [
  {
    name: '光影追梦人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20avatar%20circle%20with%20cinematic%20golden%20gradient%2C%20minimal%2C%20no%20text%20no%20face&width=100&height=100&seq=avatar-01-97movie&orientation=squarish',
    rating: 5,
    time: '2小时前',
    content: '用了97影视快一年了，资源更新速度真的没话说，热播剧当晚就能看高清版，画质清晰还不卡顿，强烈推荐给身边所有追剧的朋友！',
    movie: '《长安十二时辰》',
  },
  {
    name: '电影发烧友',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20amber%20abstract%20avatar%20circle%20with%20soft%20gradient%2C%20minimal%20design%2C%20no%20text%20no%20face&width=100&height=100&seq=avatar-02-97movie&orientation=squarish',
    rating: 5,
    time: '5小时前',
    content: '作为一个老影迷，找高清老片一直是个难题，没想到97影视收录了这么多经典电影的高清版本，画质修复得相当好，太惊喜了！',
    movie: '《霸王别姬》',
  },
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20rose%20abstract%20avatar%20circle%20with%20soft%20gradient%2C%20minimal%20design%2C%20no%20text%20no%20face&width=100&height=100&seq=avatar-03-97movie&orientation=squarish',
    rating: 4,
    time: '昨天',
    content: '最满意的是没有广告！之前用别的平台看一集能跳出三四次广告，97影视全程无广告真的体验太好了，而且加载速度也很快。',
    movie: '《破冰行动》',
  },
  {
    name: '深夜观影人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20copper%20abstract%20avatar%20circle%20with%20soft%20gradient%2C%20minimal%20design%2C%20no%20text%20no%20face&width=100&height=100&seq=avatar-04-97movie&orientation=squarish',
    rating: 5,
    time: '1天前',
    content: '移动端体验非常棒，睡前躺床上用手机看剧很方便，页面适配做得好，搜索功能也很快能找到想看的资源，给97影视团队点赞！',
    movie: '《漫长的季节》',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            观众热评
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            来自真实用户的观影反馈，你的满意是我们最大的动力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>

              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <i
                    key={idx}
                    className={`text-xs ${idx < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                {comment.content}
              </p>

              <div className="mt-4 pt-3 border-t border-background-200/60">
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400">
                  <i className="ri-film-line text-primary-400"></i>
                  {comment.movie}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}